/**
 * Zebra printer commands
 * @link https://www.zebra.com/content/dam/zebra/manuals/printers/common/programming/zpl-zbi2-pm-en.pdf
 */
export const LabelPrintCommands = {
  configuration: '^XA^HH^XZ',
  getStatus: '~HQES',
  hostStatus: '~HS',
  // Allows us to retrieve the printer's model number with a bit of massaging
  hostIdentification: '~HI',
  powerOnReset: '~JR',
  pause: '~PP',
  resume: '~PS',
  abort: '~JA',
};
